var map = {
	"./amex.png": "./src/Images/Stripe/amex.png",
	"./cb.png": "./src/Images/Stripe/cb.png",
	"./diners.png": "./src/Images/Stripe/diners.png",
	"./discover.png": "./src/Images/Stripe/discover.png",
	"./jcb.png": "./src/Images/Stripe/jcb.png",
	"./mastercard.png": "./src/Images/Stripe/mastercard.png",
	"./stripe.png": "./src/Images/Stripe/stripe.png",
	"./unionpay.png": "./src/Images/Stripe/unionpay.png",
	"./visa.png": "./src/Images/Stripe/visa.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Images/Stripe sync recursive ^\\.\\/.*$";